// extracted by mini-css-extract-plugin
module.exports = {"cd":"CD_cd_dOZdJ","wrap":"CD_wrap_1NBrD","Rotate":"CD_Rotate_oG72s","hole":"CD_hole_2yUVu"};